// Ids de la tabla areas. Tienen que coincidir con confianza-back/config/pqrs.php.
// Estaban repartidos como numeros sueltos por los componentes (1, 13, 14, 15).
export const AREA_ASESORES = 1 // SERVICIO AL CLIENTE
export const AREA_ADMIN = 14 // SUPERVISORES - el perfil Administrador

export default { AREA_ASESORES, AREA_ADMIN }
